import _defineProperty from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './MainNavigation.css';
import React, { useEffect, useState, useRef, Fragment } from 'react';
import { get, getDictionaryItem, isChina, getGlobalDictionaryTerm, isNavLinkRendered, NAV_LINKS } from '../../utils';
import clsx from 'clsx';
import { styled } from 'linaria/lib/react';
import HeaderModuleWrapper from './HeaderModuleWrapper';
import RouterLink from '../atoms/RouterLink';
import IconSearch from '../../components/atoms/Icons/IconSearch';
import IconNavclose from '../../components/atoms/Icons/IconNavclose';
import LazyPicture from '../atoms/LazyPicture';
import IconGridWorld from '../../components/atoms/Icons/IconGridWorld';
import IconTripPlanner from '../../components/atoms/Icons/IconTripPlanner';
import IconInteractiveMap from '../../components/atoms/Icons/IconInteractiveMap';
import IconFavorite from '../../components/atoms/Icons/IconFavorite';
import IconFavoriteFilled from '../../components/atoms/Icons/IconFavoriteFilled';
import { canUseDOM } from '../../utils';
import { IconClosePrimary, IconChevronRight, IconChevronLeft, IconToggleArrowDown } from '../../components/atoms/Icons';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { useStickyNav } from './useStickyNav';
import { useMobileNav } from './useMobileNav';
import { tealiumClickFunc, tealiumGenerateClickData, getLastPartInURL } from '../../utils/tealium';
import LoginBtn from './LoginBtn';
import TopPicksPopup from './TopPicksPopup';
import { getListingCancelable } from '../../utils/getListing';
import { usePageZoom } from '../../utils/hooks/usePageZoom';

/** Defines the props that are populated by data from CMS and application usage */

// NOTE: this class name is referenced in the AnchorNavigation component.
var mainNavCssClass = 'main-nav';
var brandShadow = "bzydq0a";
var CLOSED_ITEM = -1;
var MainNavigation = function MainNavigation(_ref) {
  var mainNavItems = _ref.mainNavItems,
    primaryBrandLogoLink = _ref.primaryBrandLogoLink,
    primaryBrandLogo = _ref.primaryBrandLogo,
    secondaryBrandLogo = _ref.secondaryBrandLogo,
    secondaryBrandLogoLink = _ref.secondaryBrandLogoLink,
    accountLinks = _ref.accountLinks,
    menuLinks = _ref.menuLinks,
    dictionary = _ref.dictionary,
    actions = _ref.actions,
    mainMenuAnalytics = _ref.mainMenuAnalytics,
    governmentLogoAnalytics = _ref.governmentLogoAnalytics,
    globalLinksAnalytics = _ref.globalLinksAnalytics,
    languageSelector = _ref.languageSelector,
    globalLinks = _ref.globalLinks,
    venueShortlistVisible = _ref.venueShortlistVisible,
    setVenueShortlistVisible = _ref.setVenueShortlistVisible,
    venueShortlists = _ref.venueShortlists,
    transparentNavigation = _ref.transparentNavigation,
    userProfile = _ref.userProfile;
  var isLargeNavigation = mainNavItems.length > 6;
  var _useState = useState(50),
    _useState2 = _slicedToArray(_useState, 2),
    mainNavStickyBreakpointTop = _useState2[0],
    setMainNavStickyBreakpointTop = _useState2[1];
  var _useState3 = useState(80),
    _useState4 = _slicedToArray(_useState3, 2),
    mainNavStickyBreakpointBottom = _useState4[0],
    setMainNavStickyBreakpointBottom = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    mainNav = _useState6[0],
    setMainNav = _useState6[1];
  var mainNavHolderRef = useRef(null);
  var navigationRef = useRef(null);
  var navigationContainerRef = useRef(null);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showMobileMenuOnDesktop = _useState8[0],
    setShowMobileMenuOnDesktop = _useState8[1];
  var _usePageZoom = usePageZoom(150),
    zoomLevel = _usePageZoom.zoomLevel,
    zoomedDPR = _usePageZoom.zoomedDPR;
  // 150% zoom page
  console.log(zoomLevel, zoomedDPR);
  var zoomBreakPoint = zoomedDPR;
  var _useStickyNav = useStickyNav(mainNavStickyBreakpointTop, mainNavStickyBreakpointBottom, mainNav),
    sticky = _useStickyNav.sticky,
    navVisible = _useStickyNav.navVisible,
    pageScrolled = _useStickyNav.pageScrolled;
  var _useMobileNav = useMobileNav(isLargeNavigation, showMobileMenuOnDesktop),
    mobileNavVisible = _useMobileNav.mobileNavVisible,
    mobileNavActiveIndex = _useMobileNav.mobileNavActiveIndex,
    handleMobileNavToggleClick = _useMobileNav.handleMobileNavToggleClick,
    handleMobileNavDropdownClick = _useMobileNav.handleMobileNavDropdownClick;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var plannerLabel = getGlobalDictionaryTerm(sitecoreContext, 'eventCalendarLabel') || 'Event calendar';
  var interactiveMapLabel = getGlobalDictionaryTerm(sitecoreContext, 'interactiveMapLabel') || 'Interactive map';
  var topPicksLabel = getGlobalDictionaryTerm(sitecoreContext, 'topPicksLabel') || 'Top picks';
  var searchLabel = getGlobalDictionaryTerm(sitecoreContext, 'topNavSearch') || 'Search';
  var submenuToggleLabel = getGlobalDictionaryTerm(sitecoreContext, 'toggleSubmenu') || 'toggle {name} submenu';
  var venuesLabel = getGlobalDictionaryTerm(sitecoreContext, 'topNavTrip') || 'Venues';
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var alternateUrls = get(sitecoreContext, 'alternateUrls');
  var currentLang = get(sitecoreContext, 'language');
  var primaryBrandLogoLinkHref = get(primaryBrandLogoLink, 'url', "/".concat(currentLang));
  var secondaryBrandLogoLinkHref = get(secondaryBrandLogoLink, 'url', '/');
  var indexVenues = get(sitecoreContext, 'configuration.indexValues.venues') || 'qa_venues_en';
  var menulinksArray = get(menuLinks, 'targetItem.links');
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 991px)").matches : false;
  var languageTiltle = get(languageSelector, 'targetItem.title.value');
  var initDisabledVenueShortlistTooltip = true;
  if (canUseDOM) {
    initDisabledVenueShortlistTooltip = !!localStorage.getItem('disabledVenueShortlistTooltip');
  }
  var _useState9 = useState(initDisabledVenueShortlistTooltip),
    _useState0 = _slicedToArray(_useState9, 2),
    disabledVenueShortlistTooltip = _useState0[0],
    setDisabledVenueShortlistTooltip = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    shortlistVenues = _useState10[0],
    setShortlistVenues = _useState10[1];
  var _useState11 = useState(CLOSED_ITEM),
    _useState12 = _slicedToArray(_useState11, 2),
    openedDesktopItem = _useState12[0],
    setOpenedDesktopItem = _useState12[1];
  var eventCalendar = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['eventCalendar']);
  var searchEnabled = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['search']);
  var interactiveMap = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['interactiveMap']);
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    hamburgerActiveClass = _useState14[0],
    setHamburgerActiveClass = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isVdsite = _useState16[0],
    setIsVdsite = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isShowLogo = _useState18[0],
    setIsShowLogo = _useState18[1];
  var mobNavPanelValue = useRef(10);
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isMenuFocused = _useState20[0],
    setIsMenuFocused = _useState20[1];
  var stylesNavWrapper = {
    '--mobNavPanelValue-value': "".concat(mobNavPanelValue.current, "px")
  };
  useEffect(function () {
    var nav = navigationRef.current;
    var onFocusout = function onFocusout(e) {
      if (!nav || !(e.relatedTarget instanceof Node) || !nav.contains(e.relatedTarget)) {
        setOpenedDesktopItem(CLOSED_ITEM);
      }
    };
    if (nav) {
      navigationRef.current.addEventListener('focusout', onFocusout);
    }
    return function () {
      nav && nav.removeEventListener('focusout', onFocusout);
    };
  }, []);
  useEffect(function () {
    if (!navVisible) {
      setIsMenuFocused(false);
    }
  }, [navVisible]);
  useEffect(function () {
    if (canUseDOM) {
      if (zoomLevel >= zoomBreakPoint && window.screen.width < 2560) {
        // setHamburgerActiveClass('hamburger--active');
        setShowMobileMenuOnDesktop(true);
      } else {
        setShowMobileMenuOnDesktop(false);
      }
    }
  }, [zoomLevel]);
  useEffect(function () {
    if (canUseDOM) {
      var header = document.querySelector('header');
      if (pageScrolled && header) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }
  }, [pageScrolled]);
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
        setIsShowLogo(true);
      } else setIsShowLogo(true);
      var triggerUpdate = function triggerUpdate() {
        var venues = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
        setShortlistVenues(!!venues.length);
      };
      triggerUpdate();
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return function () {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, []);
  var checkIsMobile = function checkIsMobile() {
    var mainNavTopOffsetAccum = 0;
    var mainNavBottomOffsetAccum = 0;
    var mobileDropdownOffset = 0;
    if (canUseDOM) {
      var _mainNav;
      var _stickyAnchorNav;
      var _mainNavHolder = mainNavHolderRef.current;
      var topNav = document.querySelector('.top-navigation-component');
      var alertBanner = document.querySelector('.alertBanner');
      var header = document.querySelector('header');
      if (header) {
        header.style.setProperty('--header-full-height', header.offsetHeight);
      }
      if (_mainNavHolder) {
        _mainNav = _mainNavHolder.firstChild;
        _stickyAnchorNav = _mainNavHolder.querySelector('.anchor-nav-container');
      }
      if (topNav) {
        mainNavTopOffsetAccum += topNav.offsetHeight;
      }
      if (alertBanner) {
        mainNavTopOffsetAccum += alertBanner.offsetHeight;
      }
      if (_mainNav && _mainNavHolder) {
        setMainNav(_mainNav);
        var mainNavHeight = _mainNav.offsetHeight;
        var anchorNavHeight = _stickyAnchorNav ? _stickyAnchorNav.offsetHeight : 0;
        _mainNavHolder.style.setProperty('--self-height', mainNavHeight + anchorNavHeight);
        if (_stickyAnchorNav) {
          _mainNavHolder.style.setProperty('--main-nav-translate-value', mainNavHeight + anchorNavHeight);
          _mainNavHolder.style.setProperty('--anchor-nav-height', anchorNavHeight);
          _mainNavHolder.style.setProperty('--anchor-nav-translate-value', mainNavHeight + anchorNavHeight);
        } else {
          _mainNavHolder.style.setProperty('--main-nav-translate-value', mainNavHeight);
        }
        mainNavBottomOffsetAccum = mainNavTopOffsetAccum;
        mainNavBottomOffsetAccum += mainNavHeight;
        mainNavBottomOffsetAccum += anchorNavHeight;
        var pseudo = window.getComputedStyle(_mainNav, ':after');
        var content = pseudo.getPropertyValue('content');
        mobileDropdownOffset = mainNavHeight;
        if (content !== 'none') {
          mobileDropdownOffset += parseInt(window.getComputedStyle(_mainNav, ':after').height || '0');
        }
      }
      if (mainNavTopOffsetAccum !== mainNavStickyBreakpointTop) {
        setMainNavStickyBreakpointTop(mainNavTopOffsetAccum);
      }
      if (mainNavBottomOffsetAccum !== mainNavStickyBreakpointBottom) {
        setMainNavStickyBreakpointBottom(mainNavBottomOffsetAccum);
      }
      if (mobNavPanelValue && mobNavPanelValue.current) {
        mobNavPanelValue.current = mobileDropdownOffset - 13;
      }
    }
  };
  useEffect(function () {
    if (canUseDOM) {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
      var interval = setInterval(checkIsMobile, 1000);
      return function () {
        window.removeEventListener('resize', checkIsMobile);
        clearInterval(interval);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (canUseDOM) {
      var ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      if (ids.length) {
        var itemFilters = {
          filters: ids.map(function (id) {
            return "(objectID:".concat(id, ")");
          }).join(' OR '),
          facetFilters: [['type:Venue']],
          hitsPerPage: 100,
          page: 0
        };
        getListingCancelable(indexVenues, itemFilters).promise.then(function (response) {
          if (!response.hits.length) {
            setShortlistVenues(false);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var hideVenueShortlistTooltip = function hideVenueShortlistTooltip() {
    setDisabledVenueShortlistTooltip(true);
    if (canUseDOM) {
      localStorage.setItem('disabledVenueShortlistTooltip', '1');
    }
  };
  var primaryLogos = function primaryLogos() {
    return get(primaryBrandLogo, 'jss.value.src') && /*#__PURE__*/React.createElement(RouterLink, {
      className: "brands__link",
      href: primaryBrandLogoLinkHref,
      title: get(primaryBrandLogo, 'jss.value.alt'),
      ariaLabel: get(primaryBrandLogo, 'jss.value.alt'),
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, 'Logo Govt. of Dubai');
      },
      linktype: "external",
      openInSameTab: true,
      ariaLabelledbyId: "dot-logo-title"
    }, /*#__PURE__*/React.createElement("span", {
      className: "accessibility-hidden-text",
      id: "dot-logo-title"
    }, get(primaryBrandLogo, 'jss.value.alt')), /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip dot-logo",
      alt: get(primaryBrandLogo, 'jss.value.alt'),
      "aria-hidden": "true",
      src: get(primaryBrandLogo, 'jss.value.src')
    }));
  };
  var secondaryLogos = function secondaryLogos() {
    return get(secondaryBrandLogo, 'jss.value.src') && /*#__PURE__*/React.createElement(RouterLink, {
      className: "nav-brand-secondary",
      href: secondaryBrandLogoLinkHref,
      title: get(secondaryBrandLogo, 'jss.value.alt'),
      ariaLabel: get(secondaryBrandLogo, 'jss.value.alt'),
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, 'DTCM Logo');
      },
      ariaLabelledbyId: "god-logo-title"
    }, /*#__PURE__*/React.createElement("span", {
      className: "accessibility-hidden-text",
      id: "god-logo-title"
    }, get(secondaryBrandLogo, 'jss.value.alt')), /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip god-logo",
      alt: get(secondaryBrandLogo, 'jss.value.alt'),
      "aria-hidden": "true",
      src: get(secondaryBrandLogo, 'jss.value.src')
    }));
  };
  var topPicks = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['topPicks']);
  var topPicksPopupCopy = getDictionaryItem(dictionary && dictionary.dictionary, 'TopPicksPopup');
  var relatedSites = getDictionaryItem(dictionary && dictionary.dictionary, 'relatedSites') || 'Related sites';
  var mainNavigationAccessibilityTitle = getDictionaryItem(dictionary && dictionary.commonDictionary, 'mainNavigation') || 'mainNavigation';
  return /*#__PURE__*/React.createElement("div", {
    className: "navHolder ".concat(showMobileMenuOnDesktop ? 'main-nav-overflowed' : '', " ").concat(rtl ? 'rtl' : '', " "),
    ref: mainNavHolderRef,
    style: {
      zIndex: venueShortlistVisible ? 23 : sticky || showMobileMenuOnDesktop ? 22 : 9
    }
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    transparentNavigation: transparentNavigation,
    className: clsx(mainNavCssClass, _defineProperty({}, brandShadow, !isVdsite), {
      'sticky--visible': navVisible || isMenuFocused && sticky
    }, {
      'sticky': sticky
    }, {
      'mobile-nav-visible': mobileNavVisible
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text",
    id: "main-navigation-accessibility-title"
  }, mainNavigationAccessibilityTitle), /*#__PURE__*/React.createElement("div", {
    className: "row main-navigation-block ".concat(!isVdsite ? 'brand-site' : '')
  }, !isVdsite && isShowLogo && !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: 'brand-site__logo'
  }, rtl ? primaryLogos() : secondaryLogos(), rtl ? secondaryLogos() : primaryLogos()) : '', /*#__PURE__*/React.createElement("div", {
    className: "col-auto ".concat(!isVdsite ? 'd-md-none' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-close-btn",
    onClick: handleMobileNavToggleClick
  }, /*#__PURE__*/React.createElement(IconNavclose, null)), /*#__PURE__*/React.createElement("div", {
    className: "hamburger-wrapper d-print-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hamburger".concat(mobileNavVisible ? " ".concat(hamburgerActiveClass) : ''),
    onClick: function onClick() {
      handleMobileNavToggleClick();
      tealiumClickFunc(mainMenuAnalytics, 'Mobile Top Navigation');
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hamburger__spike"
  }, " "))), /*#__PURE__*/React.createElement("div", {
    className: "brands"
  }, isVdsite && isShowLogo ? primaryLogos() : isMobile ? rtl ? primaryLogos() : secondaryLogos() : '')), /*#__PURE__*/React.createElement("div", {
    className: "col col-lg position-static",
    style: stylesNavWrapper,
    ref: navigationContainerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-wrapper",
    style: {
      top: "".concat(mobNavPanelValue.current, "px")
    }
  }, /*#__PURE__*/React.createElement("ul", {
    ref: navigationRef,
    className: "navigation"
  }, mainNavItems.map(function (item, itemIndex) {
    var targetItem = get(item, 'featuredItem.targetItem', {});
    var fallbackHeaderImage = get(targetItem, 'fallbackImage') || get(targetItem, 'headerImage');
    var urlTargetItem = get(targetItem, 'url', '');
    var featuredTitle = get(targetItem, 'title.jss.value') || get(targetItem, 'pageTitle.jss.value', '');
    var hasChildrenToShow = item.children && item.children.filter(function (el) {
      var label = el.label && el.label.value;
      var description = el.description && el.description.value;
      return label || description;
    });
    var children = hasChildrenToShow.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "drop-down-wrapper",
      "data-cy": "navigation-dropdown"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "drop-down-menu"
    }, /*#__PURE__*/React.createElement("li", {
      className: "drop-down-menu__col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nav-grid nav-grid--four"
    }, item.children.map(function (child, childIndex) {
      if (!child.label.value || child.label.value === '$name') {
        return null;
      }
      return /*#__PURE__*/React.createElement(Fragment, {
        key: "dropdown-grid-'}".concat(childIndex, "-").concat(childIndex)
      }, get(child, 'link.url') && get(child, 'label.value') ? /*#__PURE__*/React.createElement("div", {
        className: "nav-grid__list",
        key: childIndex
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: "link-chevron",
        href: get(child, 'link.url'),
        onClick: function onClick() {
          tealiumClickFunc(governmentLogoAnalytics, [getLastPartInURL(item.link.url), getLastPartInURL(child.link.url)]);
          handleMobileNavToggleClick();
        },
        dataCy: "navigation-link-chevron",
        linktype: "external",
        ariaLabel: get(child, 'label.value'),
        openInSameTab: true,
        onFocus: function onFocus() {
          return setIsMenuFocused(true);
        }
      }, child.label.value), rtl ? /*#__PURE__*/React.createElement(IconChevronLeft, {
        className: "icon-chevron-right rs_skip"
      }) : /*#__PURE__*/React.createElement(IconChevronRight, {
        className: "icon-chevron-right rs_skip"
      }), child.description && child.description.value ? /*#__PURE__*/React.createElement("p", {
        className: "dd-para"
      }, child.description.value) : null) : null);
    }))), targetItem.url && featuredTitle ? /*#__PURE__*/React.createElement("li", {
      className: "drop-down-menu__col drop-down-menu__col--banner d-none d-lg-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dd-img-placeholder"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      href: urlTargetItem,
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, "Banner Click : ".concat(targetItem && targetItem.name));
      },
      title: get(fallbackHeaderImage, 'jss.value.alt', ''),
      linktype: "external",
      tabIndex: -1,
      openInSameTab: true,
      onFocus: function onFocus() {
        return setIsMenuFocused(true);
      }
    }, fallbackHeaderImage && get(fallbackHeaderImage, 'jss.value.src', '').length && /*#__PURE__*/React.createElement(LazyPicture, {
      className: "dd-img-placeholder-inner",
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 991px)",
      srcSet: "".concat(get(fallbackHeaderImage, 'jss.value.src', ''), "&cw=216&ch=160")
    }), /*#__PURE__*/React.createElement("img", {
      className: "rs_skip",
      src: "".concat(get(fallbackHeaderImage, 'jss.value.src', ''), "&cw=216&ch=160"),
      alt: get(fallbackHeaderImage, 'jss.value.alt', '')
    })))), /*#__PURE__*/React.createElement(RouterLink, {
      className: "dd-link drop-down-menu__col-featured-link",
      href: urlTargetItem,
      title: featuredTitle,
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, "Title Click : ".concat(targetItem && targetItem.name));
      },
      linktype: "external",
      openInSameTab: true,
      onFocus: function onFocus() {
        return setIsMenuFocused(true);
      }
    }, featuredTitle)) : null)) : null;
    if (!item.label.value || item.label.value === '$name') {
      return null;
    }
    return /*#__PURE__*/React.createElement("li", {
      className: clsx('navigation__list', {
        'has-drop-down': children,
        'navigation__list--active': mobileNavActiveIndex === itemIndex,
        'navigation__list--hover': !showMobileMenuOnDesktop && openedDesktopItem === itemIndex
      }),
      key: "nav-item-".concat(itemIndex),
      onMouseEnter: function onMouseEnter() {
        return !showMobileMenuOnDesktop && setOpenedDesktopItem(itemIndex);
      },
      onMouseLeave: function onMouseLeave() {
        return !showMobileMenuOnDesktop && setOpenedDesktopItem(CLOSED_ITEM);
      }
    }, /*#__PURE__*/React.createElement(RouterLink, {
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, getLastPartInURL(item.link.url));
        handleMobileNavToggleClick();
      },
      className: "nav-link",
      href: get(item, 'link.url'),
      dataCy: "navigation-link",
      title: item.label.value,
      "aria-expanded": showMobileMenuOnDesktop ? mobileNavActiveIndex === itemIndex : isMobile ? mobileNavActiveIndex === itemIndex : openedDesktopItem === itemIndex,
      linktype: "external",
      openInSameTab: true,
      onFocus: function onFocus() {
        return setIsMenuFocused(true);
      }
    }, item.label.value, children ? /*#__PURE__*/React.createElement("span", {
      onClick: function onClick(e) {
        e.preventDefault();
        if (!showMobileMenuOnDesktop) {
          openedDesktopItem === itemIndex ? setOpenedDesktopItem(CLOSED_ITEM) : setOpenedDesktopItem(itemIndex);
        }
      },
      className: "nav-link__arrow nav-link__arrow-btn desktop-only",
      tabIndex: 0,
      "aria-expanded": showMobileMenuOnDesktop ? mobileNavActiveIndex === itemIndex : isMobile ? mobileNavActiveIndex === itemIndex : openedDesktopItem === itemIndex,
      "aria-label": submenuToggleLabel.replace('{name}', item.label.value)
    }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null)) : null), children ? /*#__PURE__*/React.createElement("span", {
      className: "nav-link__arrow mobile-only",
      onClick: function onClick() {
        tealiumClickFunc(mainMenuAnalytics, getLastPartInURL(item.link.url));
        handleMobileNavDropdownClick(itemIndex);
      }
    }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null)) : null, children);
  })), /*#__PURE__*/React.createElement("div", {
    className: "rs_skip"
  }, /*#__PURE__*/React.createElement(LoginBtn, {
    userProfile: userProfile,
    isMobileView: true,
    accountLinks: accountLinks,
    dictionary: dictionary,
    closeNav: handleMobileNavToggleClick,
    analyticsClick: function analyticsClick() {
      return tealiumClickFunc(globalLinksAnalytics, "Login");
    }
  })), languageTiltle && /*#__PURE__*/React.createElement("div", {
    className: "navigation__list d-lg-none mob-lang rs_skip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lang-selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lang-selector__label",
    htmlFor: "dd-lang-selector"
  }, languageTiltle), /*#__PURE__*/React.createElement("select", {
    className: "lang-selector__dd",
    id: "dd-lang-selector",
    onChange: function onChange(e) {
      if (canUseDOM) {
        var _window$location$path = window.location.pathname.split('/'),
          _window$location$path2 = _slicedToArray(_window$location$path, 2),
          cValue = _window$location$path2[1];
        var nValue = e.currentTarget.selectedOptions[0].value;
        window.location.href = window.location.origin + window.location.pathname.replace("/".concat(cValue, "/"), nValue);
      }
      tealiumClickFunc(globalLinksAnalytics, "Language Switch");
    }
  }, get(languageSelector, 'targetItem.children', []).map(function (lang, index) {
    var langCode = get(lang, 'languageCode.value');
    var langPath = get(languageSelector, 'currentPath');
    // const langPath = `/en/things-to-do`;
    var urlData = langPath.split('/');
    urlData.splice(0, 2).join('/');
    var newPath = urlData.join('/');
    var langCodeAndPath = "/".concat(langCode, "/").concat(newPath);
    var currentLanguagePath = langCodeAndPath.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
    if (alternateUrls && alternateUrls.some(function (obj) {
      return obj.lang === get(lang, 'languageCode.value');
    })) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        selected: get(languageSelector, 'activeLanguage.languageCode') === get(lang, 'languageCode.value'),
        value: "".concat(currentLanguagePath)
      }, get(lang, 'languageName.value'));
    } else if (!alternateUrls) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        selected: get(languageSelector, 'activeLanguage.languageCode') === get(lang, 'languageCode.value'),
        value: "".concat(currentLanguagePath)
      }, get(lang, 'languageName.value'));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "navigation__list d-lg-none related-sites rs_skip"
  }, get(globalLinks, 'targetItem.children', []).length ? /*#__PURE__*/React.createElement("div", {
    className: "nav-external"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h6 nav-external__heading"
  }, relatedSites), get(globalLinks, 'targetItem.children', []).map(function (globalLink, index) {
    var target = get(globalLink, 'link.target', '') === '' ? '_self' : globalLink.link.target;
    var rel = target === '_blank' ? 'noopener noreferrer' : undefined;
    var linkLabel = get(globalLink, 'label.value');
    var title = target === '_blank' ? "".concat(linkLabel, " | ").concat(newWindowLabel) : linkLabel;
    return /*#__PURE__*/React.createElement("a", {
      className: "nav-external__link",
      href: get(globalLink, 'link.url'),
      target: target,
      rel: rel,
      key: "top-nav-mobile-link-".concat(index),
      onClick: function onClick() {
        return tealiumClickFunc(globalLinksAnalytics, linkLabel);
      },
      title: title
    }, linkLabel);
  })) : null))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto secondary-logo-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-btns-cnt",
    "data-cy": "navigation-search-button"
  }, get(searchEnabled, 'isSearch.jss.value') && /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": searchLabel,
    className: "nav-btn search-box__link",
    onClick: function onClick() {
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'Site Search'));
      actions.onSearchClicked();
    }
  }, /*#__PURE__*/React.createElement(IconSearch, {
    className: "icon-nav-bar"
  })), get(eventCalendar, 'link.jss.value.href') && /*#__PURE__*/React.createElement(StyledActionSpan, {
    className: "nav-btn trip-planner"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: get(eventCalendar, 'link.jss.value.href'),
    onClick: function onClick() {
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'Calendar'));
    },
    title: plannerLabel,
    "aria-label": plannerLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, plannerLabel), /*#__PURE__*/React.createElement(IconTripPlanner, {
    className: "icon-nav-bar"
  }))), get(interactiveMap, 'link.jss.value.href') && /*#__PURE__*/React.createElement(StyledActionSpan, {
    className: "nav-btn interactive-map-nav corp-main-nav__action-btn "
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: get(interactiveMap, 'link.jss.value.href'),
    onClick: function onClick() {
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'Interactive Map'));
    },
    title: interactiveMapLabel,
    "aria-label": interactiveMapLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, interactiveMapLabel), /*#__PURE__*/React.createElement(IconInteractiveMap, {
    className: "icon-nav-bar"
  }))), get(topPicks, 'link.jss.value.href') && (!isChina() ? /*#__PURE__*/React.createElement("div", {
    className: "top-picks-popup-wrap nav-btn"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: get(topPicks, 'link.jss.value.href'),
    onClick: function onClick() {
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'Favorites'));
    },
    title: topPicksLabel,
    ariaLabelledbyId: "top-picks-accessibility-title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text",
    id: "top-picks-accessibility-title"
  }, topPicksLabel), /*#__PURE__*/React.createElement(StyledActionSpan, {
    className: "favorite-btn"
    // onClick={actions.onLoginClicked}
  }, /*#__PURE__*/React.createElement(IconFavorite, {
    className: "fav-heart icon-nav-bar"
  }), /*#__PURE__*/React.createElement(IconFavoriteFilled, {
    className: "fav-heart-filled icon-nav-bar"
  }))), !!venueShortlists ? null : /*#__PURE__*/React.createElement(TopPicksPopup, {
    modifier: "rs_skip",
    copy: topPicksPopupCopy
  })) : null), !!venueShortlists && /*#__PURE__*/React.createElement("div", {
    className: "main-navigation__shortlist-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn--reset",
    onClick: function onClick() {
      setVenueShortlistVisible(!venueShortlistVisible);
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'My bookmarks'));
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        setVenueShortlistVisible(!venueShortlistVisible);
        tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'My bookmarks'));
      }
    },
    title: venuesLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, venuesLabel), !!shortlistVenues ? /*#__PURE__*/React.createElement("svg", {
    className: "main-navigation__shortlist",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Z",
    transform: "translate(-25.6 -17.6)",
    fill: "var(--main-color)",
    stroke: "var(--main-color)",
    "stroke-width": "0.8"
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    className: "main-navigation__shortlist main-navigation__shortlist_inactive main-navigation__shortlist_inactive_desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Zm-6.685-6.791a.392.392,0,0,1,.2.065l6.043,5.431v-16.9a1.728,1.728,0,0,0-1.635-1.813H28.111a1.728,1.728,0,0,0-1.635,1.813v16.9l6.043-5.431A.392.392,0,0,1,32.723,31.791Z",
    transform: "translate(-25.6 -17.6)",
    fill: "#505050",
    stroke: "#505050",
    "stroke-width": "0.8"
  }))))), /*#__PURE__*/React.createElement("svg", {
    className: "main-navigation__shortlist main-navigation__shortlist_inactive main-navigation__shortlist_inactive_mobile",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Zm-6.685-6.791a.392.392,0,0,1,.2.065l6.043,5.431v-16.9a1.728,1.728,0,0,0-1.635-1.813H28.111a1.728,1.728,0,0,0-1.635,1.813v16.9l6.043-5.431A.392.392,0,0,1,32.723,31.791Z",
    transform: "translate(-25.6 -17.6)",
    fill: "var(--main-color)",
    stroke: "var(--main-color)",
    "stroke-width": "0.8"
  }))))))), !disabledVenueShortlistTooltip && getDictionaryItem(dictionary && dictionary.dictionary, 'shortlist business') !== '' && /*#__PURE__*/React.createElement("div", {
    className: "main-navigation__shortlist-hint"
  }, /*#__PURE__*/React.createElement("span", {
    className: "main-navigation__shortlist-hint-svg",
    onClick: hideVenueShortlistTooltip,
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement(IconClosePrimary, null)), getDictionaryItem(dictionary && dictionary.dictionary, 'shortlist business'))), /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": "Accessibility | AA+",
    className: "nav-btn d-lg-none rs_skip",
    onClick: function onClick() {
      actions.onAccessibilitySettingsClicked();
      tealiumClickFunc(globalLinksAnalytics, "Accessibility Option");
    }
  }, "AA+"), /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": "language",
    className: "header-tr__link header-tr__link-lang d-lg-none rs_skip",
    onClick: actions.onLanguageClicked
  }, /*#__PURE__*/React.createElement(IconGridWorld, null))), isVdsite && isShowLogo ? secondaryLogos() : isMobile ? rtl ? secondaryLogos() : primaryLogos() : ''))));
};
export default MainNavigation;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    transparentNavigation = _ref2.transparentNavigation,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: clsx(commonStyles, className, rtl ? rtlStyles : ltrStyles, _defineProperty({}, transparentNavigationStyle, transparentNavigation))
  }, children);
};
var StyledActionButton = /*#__PURE__*/styled("button")({
  name: "StyledActionButton",
  class: "s1iao2qw"
});
var StyledActionSpan = /*#__PURE__*/styled("span")({
  name: "StyledActionSpan",
  class: "sqe3i10"
});
var commonStyles = "c1ns8nus";
var ltrStyles = "l11idi9s";
var rtlStyles = "r9siij3";
var transparentNavigationStyle = "t1133lwj";